import type { Presence } from '../../../shared/protocol';
import type { PlayerState } from '../firered/player';
import type { GameSocket } from '../net/socket';

const MIN_INTERVAL_MS = 50; // no máximo ~20 envios por segundo

export const toPresence = (player: PlayerState): Presence => ({
  map: [player.mapGroup, player.mapNum],
  x: player.x,
  y: player.y,
  facing: player.facing,
  moving: player.moving,
  fast: player.fast,
  gender: player.gender,
  scene: player.scene,
  nick: player.nick,
  lead: player.lead,
});

const key = (p: Presence) =>
  `${p.map}|${p.x}|${p.y}|${p.facing}|${p.moving}|${p.fast}|${p.gender}|${p.scene}|${p.nick}|${p.lead}`;

/** Manda a nossa posição para o servidor só quando ela muda. */
export class PresenceSender {
  private lastSentKey = '';
  private lastSentAt = 0;
  private latest: Presence | null = null;

  constructor(private readonly socket: GameSocket) {
    socket.onMessage((message) => {
      // Conexão nova: o servidor não sabe onde estamos.
      if (message.t === 'welcome') this.lastSentKey = '';
    });
  }

  get current(): Presence | null {
    return this.latest;
  }

  /** Chamado a cada quadro com o estado lido da RAM. */
  tick(player: PlayerState | null, now = performance.now()): void {
    if (!player) return;
    const presence = toPresence(player);
    this.latest = presence;
    const presenceKey = key(presence);
    if (presenceKey === this.lastSentKey || now - this.lastSentAt < MIN_INTERVAL_MS) return;
    if (this.socket.send({ t: 'pos', pos: presence })) {
      this.lastSentKey = presenceKey;
      this.lastSentAt = now;
    }
  }
}
